import TitleBlock from '@anm/components/TitleBlock';
import { FC } from 'react';
import styled from 'styled-components';

export const TitleWrapper = styled(TitleBlock)`
  text-align: center;
  padding: 24px 56px 0;
  margin-bottom: 35px;
`;

type SubscriptionTitleProps = {
  children: string;
};
const SubscriptionTitle: FC<SubscriptionTitleProps> = ({ children }) => (
  <TitleWrapper size="medium-thin" title={children || ''}></TitleWrapper>
);

export default SubscriptionTitle;
